import Button from "@pathwright/ui/src/components/button/Button"
import CountIndicator from "@pathwright/ui/src/components/indicator/CountIndicator"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import styled from "styled-components"

const StyledTooltip = styled(Tooltip)`
  margin: 0 3px;
  display: flex !important;
  align-items: center;
  justify-content: center;
`

const StyledButton = styled(Button)`
  padding: 0 5px !important;
  height: 30px;
  min-width: 30px;
  line-height: 30px !important;
  border-radius: 4px !important;
  .Pathicon:not(:last-child) {
    margin-right: 3px;
  }
  .Button__content-wrapper {
    justify-content: center;
    height: 100%;
  }
`

const StyledIndicator = styled(CountIndicator)`
  top: -3px;
  right: -3px;
`

const ControlButton = ({
  icon,
  label,
  count,
  indicator,
  children,
  ...rest
}) => {
  return (
    <StyledTooltip title={label}>
      <StyledButton styleType="blank" {...rest}>
        {children ? (
          children
        ) : (
          <>
            <Pathicon icon={icon} />
            {count > 0 && <span>{count}</span>}
            {indicator && <StyledIndicator />}
          </>
        )}
      </StyledButton>
    </StyledTooltip>
  )
}

export default ControlButton
